import { render } from "./InAppBrowserRedirect.vue.ts?vue&type=template&id=c6c41923&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InAppBrowserRedirect.vue?vue&type=template&id=c6c41923&ts=true"
import script from "./InAppBrowserRedirect.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InAppBrowserRedirect.vue?vue&type=script&setup=true&lang=ts"
export * from "./InAppBrowserRedirect.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InAppBrowserRedirect.vue?vue&type=script&setup=true&lang=ts"

import "./InAppBrowserRedirect.vue.scss?vue&type=style&index=0&id=c6c41923&lang=scss!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InAppBrowserRedirect.vue?vue&type=style&index=0&id=c6c41923&lang=scss"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/merchant3/components/ui/modals/InAppBrowserRedirect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c6c41923"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c6c41923', __exports__)) {
    api.reload('c6c41923', __exports__)
  }
  
  module.hot.accept("./InAppBrowserRedirect.vue.ts?vue&type=template&id=c6c41923&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InAppBrowserRedirect.vue?vue&type=template&id=c6c41923&ts=true", () => {
    api.rerender('c6c41923', render)
  })

}


export default __exports__